// Sidebar nav arrays — extracted from app-layout-v2.tsx (ADV-805) so the
// SCREENS drift-guard test can import them without pulling supabase, auth,
// and the rest of the v2 layout's dependency graph. The layout component
// re-imports from here and continues to render the sidebar unchanged.

import {
  Briefcase,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  ClipboardCheck,
  ClipboardList,
  Contact2,
  DollarSign,
  FileText,
  LayoutDashboard,
  Map,
  MapPin,
  Package,
  Receipt,
  ShieldCheck,
  Target,
  TrendingUp,
  Upload,
  UserCheck,
  Users,
  UsersRound,
} from "lucide-react";

export type NavItemData = {
  label: string;
  icon: React.ElementType;
  href: string;
  count?: number;
  dynamicBadge?: "import-pending-review";
};

export const NAV_PRIMARY: NavItemData[] = [
  { label: "Today", icon: CalendarDays, href: "/today" },
  { label: "Dashboard", icon: LayoutDashboard, href: "/dashboard" },
  {
    label: "Opportunities",
    icon: Target,
    href: "/opportunities",
    count: 38,
  },
  { label: "Appointments", icon: CalendarCheck, href: "/appointments" },
  { label: "Jobs", icon: Briefcase, href: "/jobs", count: 47 },
  { label: "Invoices", icon: FileText, href: "/invoices", count: 14 },
  { label: "Transactions", icon: Receipt, href: "/transactions" },
  { label: "Customers", icon: Users, href: "/customers", count: 89 },
];

export const NAV_MORE: NavItemData[] = [
  { label: "Contacts", icon: Contact2, href: "/contacts" },
  { label: "Proposals", icon: ClipboardList, href: "/proposals", count: 12 },
  { label: "Products", icon: Package, href: "/products", count: 28 },
  { label: "Locations", icon: MapPin, href: "/locations" },
  { label: "Crews", icon: UsersRound, href: "/crews" },
  { label: "Team Members", icon: UserCheck, href: "/team-members" },
  { label: "Territories", icon: Map, href: "/territories" },
  { label: "Warranties", icon: ShieldCheck, href: "/warranties" },
  {
    label: "Service Agreements",
    icon: CalendarClock,
    href: "/service-agreements",
  },
  { label: "Service Plans", icon: ClipboardCheck, href: "/service-plans" },
  { label: "Commissions", icon: DollarSign, href: "/commissions" },
  { label: "Reports", icon: TrendingUp, href: "/reports" },
  {
    label: "Imports",
    icon: Upload,
    href: "/import",
    dynamicBadge: "import-pending-review",
  },
];
